/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Hub_DeliverablesInputs */



/**
* | output |
* | --- |
* | "Deliverables" |
*
* @param {Agent_Hub_DeliverablesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_hub_deliverables = /** @type {((inputs?: Agent_Hub_DeliverablesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Hub_DeliverablesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ergebnisse")
	return /** @type {LocalizedString} */ ("Deliverables")
});